import {
  ABTESTID_SUMMARIZER,
  ABTEST_SUMMARIZER_COOKIE,
  ABTESTID_TRANSLATIONOCR,
  ABTEST_TRANSLATIONOCR_COOKIE,
  ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
} from "./constants";
import { readCookie, createCookie } from "./helpers";
import { SwitchVisitorUserAbTest } from "../pages/sign-in/actions";

export const retrieveAbTestConfiguration = (abTestId, abTestCookieKey) => {
  let data = {
    abTestVariant: null,
    abTestId: null,
  };

  if (readCookie(abTestCookieKey)) {
    data = {
      abTestVariant: readCookie(abTestCookieKey),
      abTestId: abTestId,
    };
  }
  return data;
};

export const updateCookie = (abTestID, abTestVariant) => {
  if (abTestID == ABTESTID_SUMMARIZER) {
    createCookie(ABTEST_SUMMARIZER_COOKIE, abTestVariant);
  }
  else if(abTestID == ABTESTID_TRANSLATIONOCR_PROCESSIGNG)
  {
     createCookie(ABTEST_TRANSLATIONOCR_COOKIE, abTestVariant);
  }
};

export const ConductABTest = (response, portalCDVal) => {
  // check if ab test is conducted for summarizer
  let isAbTestConducted = retrieveAbTestConfiguration(ABTESTID_SUMMARIZER, ABTEST_SUMMARIZER_COOKIE);
  SwitchUserIdWithVisitorAbTest(isAbTestConducted, response, portalCDVal);
  // check if ab test is conducted for translation OCR
  let isAbTestConductedForOcr = retrieveAbTestConfiguration(
    ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
    ABTEST_TRANSLATIONOCR_COOKIE
  );
  SwitchUserIdWithVisitorAbTest(isAbTestConductedForOcr, response, portalCDVal);
};

export const SwitchUserIdWithVisitorAbTest = (isAbTestConducted, response, portalCDVal) => {
  if (isAbTestConducted.abTestId != null) {
    let switchData = {
      AbTestId: isAbTestConducted.abTestId,
      UserId: response.userGuid,
      VisitorId: readCookie("visitorGuid"),
      portalCD: portalCDVal,
    };
    //map visitorID and userGUID ABTest for summarizer
    SwitchVisitorUserAbTest(switchData).then((response) => {});
  }
};
